import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import LookWizardContent from "./lookWizardContent";
import LookCanvasContext from "../../../lookCanvasContext";
import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";
import LookWizardHeader from "./lookWizardHeader";


const LookWizardLmContent = (props) => {

  const {wizardActiveItem, isMobile} = props;

  if (!wizardActiveItem) {
    return null
  }

  return (
    <div className="lm-content lm-content--no-scroll">
      {isMobile ? (
        <header className="lm-header lm-header--with-border-bottom">
          <LookWizardHeader/>
        </header>
      ) : null}
      <LookCanvasContext.Consumer>
        {(imageCanvas) => (
          <WithUpdateLookCartItem>
            {(updateLookCartItem) => (
              <LookWizardContent imageCanvas={imageCanvas} updateLookCartItem={updateLookCartItem}/>
            )}
          </WithUpdateLookCartItem>
        )}
      </LookCanvasContext.Consumer>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardActiveItem} = store.wizardState;
  const {isMobile} = store.serverState;
  return {
    wizardActiveItem,
    isMobile,
  };
};

export default withRouter(
  connect(mapStateToProps)(LookWizardLmContent)
)
